import { Box, Flex, IconButton, Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export const ArrowNav: React.FC<{
  ids: string[];
  findCurrentIndex: (id: string) => boolean;
  generateLink: (id: string) => string;
}> = ({ ids, findCurrentIndex, generateLink }) => {
  const currentIndex = ids.findIndex(findCurrentIndex);
  const currentInsightId = ids[currentIndex];
  const prevInsightId = ids[currentIndex - 1 < 0 ? ids.length - 1 : currentIndex - 1];
  const nextInsightId = ids[currentIndex + 1 === ids.length ? 0 : currentIndex + 1];

  const generateLinkWithUndefined = (id: string | undefined) => (id ? generateLink(id) : '#');
  return (
    <Flex>
      <Text appearance="bodySmall">
        <FormattedMessage
          defaultMessage="{currentIndex, number} of {totalLength, number}"
          id="4xKsE0"
          values={{ currentIndex: currentIndex + 1, totalLength: ids.length }}
        />
      </Text>
      <Box padding={8}>
        <Link to={generateLinkWithUndefined(prevInsightId)}>
          <IconButton
            data-purpose="metrics-insights-page-carousel-button-left"
            iconName="chevron-left"
            testId="previous-button"
            title={intl.formatMessage({ defaultMessage: 'Previous', id: 'JJNc3c' })}
            disabled={!prevInsightId || prevInsightId === currentInsightId}
          />
        </Link>
      </Box>
      <Box padding={8}>
        <Link to={generateLinkWithUndefined(nextInsightId)}>
          <IconButton
            data-purpose="metrics-insights-page-carousel-button-right"
            iconName="chevron-right"
            title={intl.formatMessage({ defaultMessage: 'Next', id: '9+Ddtu' })}
            testId="next-button"
            disabled={!nextInsightId || nextInsightId === currentInsightId}
          />
        </Link>
      </Box>
    </Flex>
  );
};
